export const SESSION_CONFIG = {
    // Session duration options
    ACTIVITY_TIMEOUT_DURATION: 12 * 60 * 60 * 1000, // 12 hours in milliseconds (activity-based)
    ABSOLUTE_TIMEOUT_DURATION: 24 * 60 * 60 * 1000,  // 24 hours absolute maximum (security limit)
    WARNING_DURATION: 15 * 60 * 1000,                // Show warning 15 minutes before timeout
    PING_INTERVAL: 30 * 60 * 1000,                   // Check session every 30 minutes
    
    // Session management strategy
    // Options: 
    // - 'activity': Reset timer on user activity (recommended for 12-hour sessions)
    // - 'absolute': Fixed duration from login (more secure)
    // - 'disabled': Rely entirely on Firebase Auth (no custom timeout)
    TIMEOUT_STRATEGY: 'activity',
    
    // Security settings
    ENABLE_IDLE_WARNING: true,  // Show warning before timeout
    ENABLE_AUTO_REFRESH: true,  // Automatically refresh tokens periodically
    
    // Quick presets - uncomment one to use
    // For 12-hour relaxed sessions (current config):
    // TIMEOUT_STRATEGY: 'activity', ACTIVITY_TIMEOUT_DURATION: 12 * 60 * 60 * 1000
    
    // For Firebase-only sessions (no custom timeout):
    // TIMEOUT_STRATEGY: 'disabled'
    
    // For secure 2-hour sessions:
    // TIMEOUT_STRATEGY: 'absolute', ABSOLUTE_TIMEOUT_DURATION: 2 * 60 * 60 * 1000
};